'use client';

import { error_500 } from '@/images';
import { reloadOnChunkLoadError } from '@/utils/chunkReload.util';
import { ArrowLeft } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error.digest);

    reloadOnChunkLoadError(error);
  }, [error]);

  return (
    <section className='flex h-screen flex-col items-center justify-center gap-4 px-4'>
      <Image
        src={error_500}
        alt='error_500'
        className='w-[20rem] md:w-[30rem]'
        width={500}
        height={500}
      />
      <p className='text-primary/90 text-center text-4xl font-bold md:text-5xl'>
        Server Error
      </p>
      <p className='max-w-[30rem] text-center text-base font-medium text-pretty text-gray-900 md:text-lg'>
        Snap, something broke! Be rest assured, we have our best minds working
        on addressing this issue. We&apos;ll get this sorted soon!
      </p>
      <Link
        className='bg-primary/90 hover:bg-primary flex items-center gap-2 rounded-sm px-4 py-2 font-medium text-white'
        href='/'
      >
        <ArrowLeft strokeWidth={2.5} className='size-5' />
        <p>Back to homepage</p>
      </Link>
    </section>
  );
}
